import { MdOutlineLocalFireDepartment } from 'react-icons/md';
import { FaRegStar, FaRegFaceGrinTongueWink } from 'react-icons/fa6';
import { ImCoinDollar } from 'react-icons/im';
import { RiCopperCoinFill } from 'react-icons/ri';
export const SEARCH_MENU_ITEMS = [
    { label: 'Memes', icon: FaRegFaceGrinTongueWink, modeValue: 'memes', displayName: 'Verified' },
    // { label: 'Hot', icon: MdOutlineLocalFireDepartment, modeValue: 'hot', },
    // { label: 'Gainers', icon: FaRegStar, modeValue: 'gainers' },
    // { label: 'New', icon: FaRegStar, modeValue: 'new' },
    { label: 'Top', icon: FaRegStar, modeValue: 'top' },
    { label: 'Natives', icon: RiCopperCoinFill, modeValue: 'native' },
    { label: 'Cash', icon: ImCoinDollar, modeValue: 'cash' },
];
export const DTSEARCH_MENU_ITEMS = [
    { label: 'Memes', icon: FaRegFaceGrinTongueWink, modeValue: 'memes', displayName: 'Verified' },
    { label: 'Hot', icon: MdOutlineLocalFireDepartment, modeValue: 'hot', },
    { label: 'Gainers', icon: FaRegStar, modeValue: 'gainers' },
    { label: 'New', icon: FaRegStar, modeValue: 'new' },
    { label: 'Top', icon: FaRegStar, modeValue: 'top' },
    { label: 'Natives', icon: RiCopperCoinFill, modeValue: 'native' },
    { label: 'Cash', icon: ImCoinDollar, modeValue: 'cash' },
    { label: 'Saved', icon: FaRegStar, modeValue: 'saved' },
];
export const MEMES_SUB_MENU = [
    { label: 'All', modeValue: 'Trending', isImage: 'genius.png' },
    { label: 'AI', modeValue: 'AI', img: '🤖' },
    { label: 'Dogs', modeValue: 'Dogs', img: '🐕' },
    { label: 'Cats', modeValue: 'Cats', img: '🐈' },
    { label: 'Frogs', modeValue: 'Frogs', img: '🐸' },
    { label: 'TikTok', modeValue: 'TikTok', img: '🐸', isImage: 'tiktok.png' },
    { label: 'Politics', modeValue: 'Politics', img: '✊' },
    { label: 'Stocks', modeValue: 'Stocks', img: '📈' },
];
